import { ExternalBillingClaimStatus } from "@/Common/Api/ExternalBilling/Dto/ExternalBillingClaimStatus";
import { AdministrativeCode, BatchEligibilityCheckStatusEnum, PopulationBasedFundingEventAction, PopulationBasedFundingEventDeregisteredReason, PopulationBasedFundingEventOverrideReason, PopulationBasedFundingProposalReason } from "../UI/Enums";
import { PopulationBasedFundingEventNoteModel } from "./PopulationBasedFundingEventNoteModel";

class PopulationBasedFundingEventWithNotesModel {
    public Id: string;
    public PatientContactFacetId: string;
    public EmployeeContactFacetId: string;
    public ActionEnum: PopulationBasedFundingEventAction;
    public EffectiveDate: Date;
    public IsInternalProposal: boolean;
    public IsLatestInPatientHistory: boolean;
    public ProposalDate?: Date;
    public DeregisteredReasonEnum?: PopulationBasedFundingEventDeregisteredReason;
    public OverrideReasonEnum?: PopulationBasedFundingEventOverrideReason;
    public AcceptedDate: Date;
    public AcceptedBy?: string;
    public CreatedDate: Date;
    public CreatedBy: string;
    public LastUpdateDate: Date;
    public LastUpdatedBy: string;
    public WillContinueTreatment: boolean;
    public ProposalReason?: PopulationBasedFundingProposalReason;
    public OverrideDate?: Date;
    public DeregistrationOrProposalCustomReason?: string;
    public Notes: PopulationBasedFundingEventNoteModel[];
    public BatchEligibilityCheckStatusEnum: BatchEligibilityCheckStatusEnum | null;
    public IsPatientTransfered: boolean;
    public ClaimStatus: ExternalBillingClaimStatus | null;
    public AdministrativeCode: AdministrativeCode;

    public constructor(init?: Partial<PopulationBasedFundingEventWithNotesModel>) {
        Object.assign(this, init);
    }

    public get isPendingProposal(): boolean {
        return this.isProposal && !this.AcceptedDate && !this.OverrideDate;
    }

    public get isProposal(): boolean {
        return !!this.ProposalDate;
    }

    public get isPendingOrOverriddenProposal(): boolean {
        return this.isPendingProposal || this.isOverride;
    }

    public get isAcceptedInternalProposal(): boolean {
        return this.IsInternalProposal && this.isAccepted;
    }

    public get isOverride(): boolean {
        return !!this.isProposal && !!this.OverrideDate;
    }

    public get isAccepted(): boolean {
        return !!this.isProposal && !!this.AcceptedDate;
    }

    public get isRegistered(): boolean {
        let resolvedStatus: PopulationBasedFundingEventAction = this.ActionEnum;

        if (this.BatchEligibilityCheckStatusEnum === BatchEligibilityCheckStatusEnum.NotRegistered)
            return false;

        if (this.isOverride || this.isPendingProposal) {
            resolvedStatus = this.ActionEnum === PopulationBasedFundingEventAction.Register
                ? PopulationBasedFundingEventAction.Deregister
                : PopulationBasedFundingEventAction.Register;
        }

        return resolvedStatus === PopulationBasedFundingEventAction.Register;
    }

    public get isPendingInternalProposal(): boolean {
        return this.IsInternalProposal && !this.AcceptedDate;
    }
}

export { PopulationBasedFundingEventWithNotesModel };
